import { axios, getAxiosConfig } from '@config/axios';
import Environment from '@config/index';
import logger from '@helpers/utils/logger/client';

const apiBaseUrl = Environment.apiBaseUrl;

export interface ShoppingPrefsPayload {
  universe?: number;
  categories?: number[];
  custom?: string[];
  updated_at?: string;
}

export class UserShoppingPreferencesService {
  static url = `${apiBaseUrl}/users/me/shopping-preferences`;

  static async getShoppingPrefs(): Promise<ShoppingPrefsPayload> {
    const axiosConfig = getAxiosConfig();
    try {
      const { data } = await axios.get<ShoppingPrefsPayload>(this.url, axiosConfig);
      return data;
    } catch (error) {
      logger.error('shopping-preferences-service::getShoppingPrefs::', error?.response?.data);
      throw error;
    }
  }

  static async updateShoppingPrefs(payload: ShoppingPrefsPayload): Promise<void> {
    const axiosConfig = getAxiosConfig();
    try {
      await axios.patch(this.url, payload, axiosConfig);
    } catch (error) {
      logger.error('shopping-preferences-service::updateShoppingPrefs::', error?.response?.data);
      throw error;
    }
  }
}
